// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_SZDdX","secondaryColumnCell":"secondary-column-cell_SZDdX","container":"container_eoY2o","field":"field_K_iaj","label":"label_S6nGU"};